<script>
  import Modal from '@components/general/modal.svelte'
  import Form from '@components/forms'
  import Button from '@components/buttons/button.svelte'
  import ContributorSelect from '@components/inputs/contributor-select.svelte'
  import { useForm } from '@inertiajs/svelte'
  import { Save } from 'lucide-svelte'

  let { video, open = $bindable(false), onClose } = $props()

  let activeOptions = [
    { value: false, label: "Hidden" },
    { value: true, label: "Visible" },
  ]

  let freeOptions = [
    { value: true, label: "Free" },
    { value: false, label: "Premium" },
  ]

  const form = $derived(useForm({
    contributor_id: video?.contributor_id,
    active: video?.active,
    free: video?.free,
  }))

  let formId = $derived(`video-form-${video.id}`)

  function handleClose() {
    onClose?.()
    $form.reset()
    open = false
  }

  function handleSubmit(e) {
    e.preventDefault()
    $form.transform((data) => {
      return { video: data }
    })
    $form.patch(`/admin/videos/${video.id}`, { onSuccess: handleClose })
  }

</script>

<Modal bind:open title={video?.name || 'Edit video'} onClose={handleClose}>

  <Form.Element {form} id={formId} onsubmit={handleSubmit}>

    <Form.Items>

      <ContributorSelect bind:value={$form.contributor_id} label="Contributor" />

      <Form.Item name="active" bind:value={$form.active} label="Visibility" hint={$form.active ? "Video is visible to users" : "Video is hidden from users"} cols={12} options={activeOptions} />

      <Form.Item name="free" bind:value={$form.free} label="Access level" hint={$form.free ? "Video is free to view" : "Video requires premium access"} cols={12} options={freeOptions} />

    </Form.Items>

  </Form.Element>

  {#snippet footer()}
    <Button type="submit" form={formId} text="Save" variant="submit" Icon={Save} loading={$form.processing} />
  {/snippet}

</Modal>
